var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraCommitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm5.2,7.65-5.08,6a1,1,0,0,1-.73.35h0a1,1,0,0,1-.7-.29L7.73,12.78a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l2.14,2.15,4.39-5.17a1,1,0,0,1,1.52,1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraCommitted);
export default __webpack_public_path__ + "static/media/cra-committed.4d118c4bfd0e442f5f6ca7346506ea6a.svg";
export { ForwardRef as ReactComponent };